'use client';

import {
  ServicePageNavigationFragment,
  ServicePageStoreFragment,
} from '@business/gql/graphql';
import { Maybe } from 'graphql/jsutils/Maybe';
import { useMemo } from 'react';
import { Popover } from '@headlessui/react';
import { cn } from '@ngg/storefront-utils';
import Icon from '../icon/icon';
import { MenuItems } from './MenuItems';
import config from '@utils/config';

export const MobileMenu = ({
  navigations,
  storeData,
  slug,
  hideNavigation,
  className,
}: {
  navigations?: Maybe<ServicePageNavigationFragment>[] | null;
  storeData?: Maybe<ServicePageStoreFragment>;
  slug: string;
  hideNavigation?: boolean;
  className?: string;
}) => {
  const { locale } = config;

  const active = useMemo(() => {
    let output = '';
    let parent = '';

    if (!navigations?.length) {
      return {
        output,
        parent,
      };
    }

    for (let i = 0; i < navigations?.length; i += 1) {
      const navigation = navigations[i];

      if (navigation?.sublinksCollection?.items.length) {
        for (
          let j = 0;
          j < navigation?.sublinksCollection?.items.length;
          j += 1
        ) {
          const item = navigation.sublinksCollection.items[j];

          if (item?.internalLink?.slug === slug) {
            output = item?.title ?? '';
          }

          parent = navigation.title ?? '';
        }
      }
    }

    return {
      output,
      parent,
    };
  }, [slug, navigations]);

  if (hideNavigation) {
    return null;
  }

  return (
    <Popover as="div" className={cn('mb-6 px-3 lg:hidden', className)}>
      <Popover.Button
        type="button"
        className="flex w-full items-center justify-between border border-beige bg-transparent px-3 py-2 font-sans text-sm font-bold focus:outline-none">
        {active?.output || active?.parent}
        <Icon name="rightArrowWithTail" size={16} />
      </Popover.Button>

      <Popover.Overlay className="fixed inset-0 z-20 bg-black/70 lg:hidden" />

      <MenuItems
        slug={slug}
        locale={locale}
        storeData={storeData}
        navigations={navigations}
      />
    </Popover>
  );
};
